import React, { ReactNode } from 'react';
import { Button } from '@mantine/core';
import { useFormStatus } from 'react-dom';

const ServerActionSubmitButton = ({
  children,
  icon,
  iconRight,
}: {
  children: ReactNode;
  icon?: ReactNode;
  iconRight?: ReactNode;
}) => {
  //this must be inside a <form> tag to pick up the form status
  const { pending } = useFormStatus();

  return (
    <Button
      fullWidth
      color="dark"
      data-testid="SignIn:Submit"
      type="submit"
      loading={pending}
      disabled={pending}
      leftSection={icon}
      rightSection={iconRight}
    >
      {children}
    </Button>
  );
};

export default ServerActionSubmitButton;
